// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/NetworkModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { PagingInfo } from "./SystemModels";

export const protobufPackage = "daisi.protos.v1";

export enum NetworkStatus {
  NetworkStatusUnapproved = 0,
  NetworkStatusArchived = 1,
  NetworkStatusApproved = 2,
  UNRECOGNIZED = -1,
}

export function networkStatusFromJSON(object: any): NetworkStatus {
  switch (object) {
    case 0:
    case "NetworkStatusUnapproved":
      return NetworkStatus.NetworkStatusUnapproved;
    case 1:
    case "NetworkStatusArchived":
      return NetworkStatus.NetworkStatusArchived;
    case 2:
    case "NetworkStatusApproved":
      return NetworkStatus.NetworkStatusApproved;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NetworkStatus.UNRECOGNIZED;
  }
}

export function networkStatusToJSON(object: NetworkStatus): string {
  switch (object) {
    case NetworkStatus.NetworkStatusUnapproved:
      return "NetworkStatusUnapproved";
    case NetworkStatus.NetworkStatusArchived:
      return "NetworkStatusArchived";
    case NetworkStatus.NetworkStatusApproved:
      return "NetworkStatusApproved";
    case NetworkStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetNetworksRequest {
  Paging?: PagingInfo | undefined;
  NetworkId?: string | undefined;
  IsPublic: boolean;
}

export interface GetNetworksResponse {
  Networks: Network[];
  TotalCount: number;
}

export interface UpdateNetworkRequest {
  Network?: Network | undefined;
}

export interface UpdateNetworkResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface ArchiveNetworkRequest {
  NetworkId: string;
}

export interface ArchiveNetworkResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface CreateNetworkRequest {
  Network?: Network | undefined;
}

export interface CreateNetworkResponse {
  Network?: Network | undefined;
  Response?: string | undefined;
}

export interface Network {
  Id: string;
  AccountId: string;
  AccountName: string;
  Name: string;
  Description: string;
  IsPublic: boolean;
  Status: NetworkStatus;
}

function createBaseGetNetworksRequest(): GetNetworksRequest {
  return { Paging: undefined, NetworkId: undefined, IsPublic: false };
}

export const GetNetworksRequest: MessageFns<GetNetworksRequest> = {
  encode(message: GetNetworksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(10).fork()).join();
    }
    if (message.NetworkId !== undefined) {
      writer.uint32(18).string(message.NetworkId);
    }
    if (message.IsPublic !== false) {
      writer.uint32(24).bool(message.IsPublic);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNetworksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNetworksRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.NetworkId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.IsPublic = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNetworksRequest {
    return {
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
      NetworkId: isSet(object.NetworkId) ? globalThis.String(object.NetworkId) : undefined,
      IsPublic: isSet(object.IsPublic) ? globalThis.Boolean(object.IsPublic) : false,
    };
  },

  toJSON(message: GetNetworksRequest): unknown {
    const obj: any = {};
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    if (message.NetworkId !== undefined) {
      obj.NetworkId = message.NetworkId;
    }
    if (message.IsPublic !== false) {
      obj.IsPublic = message.IsPublic;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNetworksRequest>, I>>(base?: I): GetNetworksRequest {
    return GetNetworksRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNetworksRequest>, I>>(object: I): GetNetworksRequest {
    const message = createBaseGetNetworksRequest();
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    message.NetworkId = object.NetworkId ?? undefined;
    message.IsPublic = object.IsPublic ?? false;
    return message;
  },
};

function createBaseGetNetworksResponse(): GetNetworksResponse {
  return { Networks: [], TotalCount: 0 };
}

export const GetNetworksResponse: MessageFns<GetNetworksResponse> = {
  encode(message: GetNetworksResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Networks) {
      Network.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNetworksResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNetworksResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Networks.push(Network.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNetworksResponse {
    return {
      Networks: globalThis.Array.isArray(object?.Networks) ? object.Networks.map((e: any) => Network.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetNetworksResponse): unknown {
    const obj: any = {};
    if (message.Networks?.length) {
      obj.Networks = message.Networks.map((e) => Network.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNetworksResponse>, I>>(base?: I): GetNetworksResponse {
    return GetNetworksResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNetworksResponse>, I>>(object: I): GetNetworksResponse {
    const message = createBaseGetNetworksResponse();
    message.Networks = object.Networks?.map((e) => Network.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseUpdateNetworkRequest(): UpdateNetworkRequest {
  return { Network: undefined };
}

export const UpdateNetworkRequest: MessageFns<UpdateNetworkRequest> = {
  encode(message: UpdateNetworkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Network !== undefined) {
      Network.encode(message.Network, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNetworkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNetworkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Network = Network.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNetworkRequest {
    return { Network: isSet(object.Network) ? Network.fromJSON(object.Network) : undefined };
  },

  toJSON(message: UpdateNetworkRequest): unknown {
    const obj: any = {};
    if (message.Network !== undefined) {
      obj.Network = Network.toJSON(message.Network);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNetworkRequest>, I>>(base?: I): UpdateNetworkRequest {
    return UpdateNetworkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNetworkRequest>, I>>(object: I): UpdateNetworkRequest {
    const message = createBaseUpdateNetworkRequest();
    message.Network = (object.Network !== undefined && object.Network !== null)
      ? Network.fromPartial(object.Network)
      : undefined;
    return message;
  },
};

function createBaseUpdateNetworkResponse(): UpdateNetworkResponse {
  return { Success: false, Message: undefined };
}

export const UpdateNetworkResponse: MessageFns<UpdateNetworkResponse> = {
  encode(message: UpdateNetworkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNetworkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNetworkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNetworkResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: UpdateNetworkResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNetworkResponse>, I>>(base?: I): UpdateNetworkResponse {
    return UpdateNetworkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNetworkResponse>, I>>(object: I): UpdateNetworkResponse {
    const message = createBaseUpdateNetworkResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseArchiveNetworkRequest(): ArchiveNetworkRequest {
  return { NetworkId: "" };
}

export const ArchiveNetworkRequest: MessageFns<ArchiveNetworkRequest> = {
  encode(message: ArchiveNetworkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.NetworkId !== "") {
      writer.uint32(10).string(message.NetworkId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveNetworkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveNetworkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.NetworkId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveNetworkRequest {
    return { NetworkId: isSet(object.NetworkId) ? globalThis.String(object.NetworkId) : "" };
  },

  toJSON(message: ArchiveNetworkRequest): unknown {
    const obj: any = {};
    if (message.NetworkId !== "") {
      obj.NetworkId = message.NetworkId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveNetworkRequest>, I>>(base?: I): ArchiveNetworkRequest {
    return ArchiveNetworkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveNetworkRequest>, I>>(object: I): ArchiveNetworkRequest {
    const message = createBaseArchiveNetworkRequest();
    message.NetworkId = object.NetworkId ?? "";
    return message;
  },
};

function createBaseArchiveNetworkResponse(): ArchiveNetworkResponse {
  return { Success: false, Message: undefined };
}

export const ArchiveNetworkResponse: MessageFns<ArchiveNetworkResponse> = {
  encode(message: ArchiveNetworkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveNetworkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveNetworkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveNetworkResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: ArchiveNetworkResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveNetworkResponse>, I>>(base?: I): ArchiveNetworkResponse {
    return ArchiveNetworkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveNetworkResponse>, I>>(object: I): ArchiveNetworkResponse {
    const message = createBaseArchiveNetworkResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseCreateNetworkRequest(): CreateNetworkRequest {
  return { Network: undefined };
}

export const CreateNetworkRequest: MessageFns<CreateNetworkRequest> = {
  encode(message: CreateNetworkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Network !== undefined) {
      Network.encode(message.Network, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateNetworkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateNetworkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Network = Network.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateNetworkRequest {
    return { Network: isSet(object.Network) ? Network.fromJSON(object.Network) : undefined };
  },

  toJSON(message: CreateNetworkRequest): unknown {
    const obj: any = {};
    if (message.Network !== undefined) {
      obj.Network = Network.toJSON(message.Network);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateNetworkRequest>, I>>(base?: I): CreateNetworkRequest {
    return CreateNetworkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateNetworkRequest>, I>>(object: I): CreateNetworkRequest {
    const message = createBaseCreateNetworkRequest();
    message.Network = (object.Network !== undefined && object.Network !== null)
      ? Network.fromPartial(object.Network)
      : undefined;
    return message;
  },
};

function createBaseCreateNetworkResponse(): CreateNetworkResponse {
  return { Network: undefined, Response: undefined };
}

export const CreateNetworkResponse: MessageFns<CreateNetworkResponse> = {
  encode(message: CreateNetworkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Network !== undefined) {
      Network.encode(message.Network, writer.uint32(10).fork()).join();
    }
    if (message.Response !== undefined) {
      writer.uint32(18).string(message.Response);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateNetworkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateNetworkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Network = Network.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Response = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateNetworkResponse {
    return {
      Network: isSet(object.Network) ? Network.fromJSON(object.Network) : undefined,
      Response: isSet(object.Response) ? globalThis.String(object.Response) : undefined,
    };
  },

  toJSON(message: CreateNetworkResponse): unknown {
    const obj: any = {};
    if (message.Network !== undefined) {
      obj.Network = Network.toJSON(message.Network);
    }
    if (message.Response !== undefined) {
      obj.Response = message.Response;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateNetworkResponse>, I>>(base?: I): CreateNetworkResponse {
    return CreateNetworkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateNetworkResponse>, I>>(object: I): CreateNetworkResponse {
    const message = createBaseCreateNetworkResponse();
    message.Network = (object.Network !== undefined && object.Network !== null)
      ? Network.fromPartial(object.Network)
      : undefined;
    message.Response = object.Response ?? undefined;
    return message;
  },
};

function createBaseNetwork(): Network {
  return { Id: "", AccountId: "", AccountName: "", Name: "", Description: "", IsPublic: false, Status: 0 };
}

export const Network: MessageFns<Network> = {
  encode(message: Network, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.AccountName !== "") {
      writer.uint32(26).string(message.AccountName);
    }
    if (message.Name !== "") {
      writer.uint32(34).string(message.Name);
    }
    if (message.Description !== "") {
      writer.uint32(42).string(message.Description);
    }
    if (message.IsPublic !== false) {
      writer.uint32(48).bool(message.IsPublic);
    }
    if (message.Status !== 0) {
      writer.uint32(56).int32(message.Status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Network {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNetwork();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.AccountName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.IsPublic = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.Status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Network {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      AccountName: isSet(object.AccountName) ? globalThis.String(object.AccountName) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
      IsPublic: isSet(object.IsPublic) ? globalThis.Boolean(object.IsPublic) : false,
      Status: isSet(object.Status) ? networkStatusFromJSON(object.Status) : 0,
    };
  },

  toJSON(message: Network): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.AccountName !== "") {
      obj.AccountName = message.AccountName;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    if (message.IsPublic !== false) {
      obj.IsPublic = message.IsPublic;
    }
    if (message.Status !== 0) {
      obj.Status = networkStatusToJSON(message.Status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Network>, I>>(base?: I): Network {
    return Network.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Network>, I>>(object: I): Network {
    const message = createBaseNetwork();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.AccountName = object.AccountName ?? "";
    message.Name = object.Name ?? "";
    message.Description = object.Description ?? "";
    message.IsPublic = object.IsPublic ?? false;
    message.Status = object.Status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
